export default "__VITE_ASSET__BO8w_2rR__"